import request from '@/utils/request'

export function login(query) {
  return request({
    url: '/auth/login',
    method: 'post',
    data:query
  })
}

export function getInfo(token) {
  return request({
    url: '/vue-element-admin/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  })
}

export function ResetPassword(params) {
  return request({
    url: '/business/sysUser/password',
    method: 'post',
    data: params
  })
}

export function getMenu() {
  return request({
    url: '/system/appmenu/getRouters?appId=doctor',
    method: 'get',
    params: {}
  })
}

